<script>
// import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name    : "accordion",
  props   : {
    label: {
      type: String,
    },
  },
  data () {
    return {
      initialLoad: true,
      debug      : false
    }
  },
  methods : {

  },
  mounted () {

  },
}
</script>

<template>
  <div class="accordion">
    {{label}}
  </div>
</template>

<style scoped lang="scss">
  .accordion {
    display: flex;
  }
</style>
